import React from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

function ModalSearch({ modal, toggle }) {
  return <></>
}

export default ModalSearch
